import { Alert, Box, Chip, Grid2, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import type { UserPresence } from '../../../_hubs/auctionUser.hub';

const alertSx = {
    fontSize: { xs: 16, sm: 18 },
    alignItems: 'center',
    '& .MuiAlert-icon': {
        fontSize: 28,
        '& .MuiSvgIcon-root': { fontSize: 'inherit' },
    },
};

function presenceConfig(presence: UserPresence) {
    if (presence === 'online') {
        return {
            severity: 'success' as const,
            chipColor: 'success' as const,
            title: 'Online',
            message: 'You are connected and this tab is active.',
        };
    }
    if (presence === 'away') {
        return {
            severity: 'warning' as const,
            chipColor: 'warning' as const,
            title: 'Away',
            message: 'This tab is not in focus. Keep this window open and in front during the auction — background tabs can miss updates and may affect your participation.',
        };
    }
    if (presence === 'reconnecting') {
        return {
            severity: 'info' as const,
            chipColor: 'info' as const,
            title: 'Reconnecting',
            message: 'Connection lost — trying to reconnect. Please wait.',
        };
    }
    return {
        severity: 'error' as const,
        chipColor: 'error' as const,
        title: 'Offline',
        message: 'You are disconnected from the auction. Refresh this page once your connection is restored.',
    };
}

export function CatalogueItemOnlineCard(params: { presence: UserPresence }) {
    const config = presenceConfig(params.presence);

    return (
        <Grid2 size={{ xs: 12 }}>
            <Alert sx={alertSx} elevation={1} severity={config.severity} icon={<CircleIcon sx={{ fontSize: 14 }} />}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
                    <Chip size="small" label={config.title} color={config.chipColor} variant="filled" sx={{ fontWeight: 600 }} />
                    <Typography component="span" variant="body1" sx={{ flex: 1, minWidth: 200 }}>
                        {config.message}
                    </Typography>
                </Box>
            </Alert>
        </Grid2>
    );
}
